<template>
    <span><a href="#" @click.prevent="handleClick" class="btn navbar-btn btn-signin">Logga in</a></span>
</template>

<script>
export default {
    methods: {
        handleClick: function () {
            $('#login-modal').modal('show');
        }
    }
};
</script>
